import { callApiToServer } from "../callApi";

export async function editTestimonial(authtoken, values) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(values);

    console.log(body);

    let endUrl = "v1/auth/admin/edit-testimonial";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
